import { TEAMMEMBERLIST_SEARCH, TEAMMEMBERLIST_PAGE } from '../actions/teammemberlistactions';

const state = { search: '', page: 0 };

const getters = {
    page: state => state.page,
    search: state => state.search
};

const actions = {
    [TEAMMEMBERLIST_SEARCH]: ({ commit }, search) => {
        commit(TEAMMEMBERLIST_SEARCH, search);
    },
    [TEAMMEMBERLIST_PAGE]: ({ commit }, page) => {
        commit(TEAMMEMBERLIST_PAGE, page);
    }
};

const mutations = {
    [TEAMMEMBERLIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [TEAMMEMBERLIST_PAGE]: (state, page) => {
        state.page = page;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};